<!-- src/App.vue -->
<template>
  <router-view :key="$route.fullPath" />
</template>

<script setup>
import { onMounted, watch } from "vue";
import { useThemeStore } from "@/stores/theme";

const themeStore = useThemeStore();

// Watch para mudanças de tema e aplicar no HTML
watch(
  () => themeStore.currentTheme,
  (newTheme) => {
    document.documentElement.setAttribute("data-theme", newTheme);
  },
  { immediate: true },
);

onMounted(() => {
  themeStore.initTheme();
  // Habilita transições após o carregamento inicial (previne flash)
  requestAnimationFrame(() => {
    document.documentElement.classList.add("app-loaded");
  });
});
</script>

<style>
/* Estilos globais base - variáveis definidas em theme.css */
button {
  font-family: inherit;
}

a {
  color: inherit;
  text-decoration: none;
}

img {
  max-width: 100%;
  height: auto;
}

/* Reset para inputs */
input,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
}
</style>
